import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PendingLetterInfo } from '../DTOs/pending-letter-info';
import { PendingLettersService } from '../pending-letters.service';
import { UpdateLetterRequest } from '../DTOs/update-letter-request';

@Component({
  selector: 'app-edit-letter-content-modal',
  templateUrl: './edit-letter-content-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EditLetterContentModalComponent {

    constructor(private pendingLettersService: PendingLettersService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private activeModal: NgbActiveModal) { }

    letter: PendingLetterInfo;

    dismiss(): void {
        this.activeModal.dismiss();
    }

    UpdateLetter() {
        const req = new UpdateLetterRequest();
        req.letterId = this.letter.letterId;
        req.letterContent = this.letter.letterContent;
        this.pendingLettersService.updateLetter(req).subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                this.activeModal.close();
            }
        });;
    }
}
